import { observable, action} from 'mobx';
import { useStrict } from 'mobx';
import {date, time} from './index';

useStrict(false);
export default class NewsStore {
    constructor(){
        this.setNewDay();
    }

    @observable newsList = [];

    @action setNewDay(){
        this.newsList = [
            {   type:this.setMassageType('weather'),
                date:`${date.day.getDate()}.${date.day.getMonth()}.${date.day.getFullYear()} ${time.getTime}`,
                font: date.weather.type === 0 ? 'sun-o' :
                    date.weather.type === 1 ? 'tint' :
                        'cloud',
                massage:  date.weather.type === 0 ? "Погода: Сонячно." :
                    date.weather.type === 1 ? "Погода: Дощі." :
                        "Погода: Сьогодні хмарно."
            },
            {   type:this.setMassageType('input'),
                date:`${ date.day.getDate()}.${date.day.getMonth()}.${date.day.getFullYear()} ${ time.getTime}`,
                font:'exclamation-circle',
                massage: 'Почався новий день.'
            }
        ];
    }
    cultures = {
        wheat: "пшениці",
        corn: "кукурудзи",
        soy: "сої",
        sunflower:"соняшника",
        rape:"ріпаку"
    };
    @action addShipmentErrorMessage(){
        this.newsList.unshift(
            {
                type:this.setMassageType('alert'),
                date:`${ date.day.getDate()}.${date.day.getMonth()}.${date.day.getFullYear()} ${ time.getTime}`,
                font:'arrow-circle-down',
                massage:`Замовлений вами транспорт не прибув до станції відвантаження. Очікуваний час прибуття - завтра.`
            }
        );
    }
    @action addInputMassage(transport,type){
        this.newsList.unshift(
            {
                type:this.setMassageType('input'),
                date:`${ date.day.getDate()}.${date.day.getMonth()}.${date.day.getFullYear()} ${ time.getTime}`,
                font:'arrow-circle-down',
                massage:`Приймання: ${transport.item*20} тон ${this.cultures[transport.culture]} (вологість ${transport.moisture}%, смітність ${transport.waste}%) прибуло ${type === "truck" ? "автотранспортом" : "залізницею"}. `
            }
        );
    }

    setMassageType(item) {
        let result;
        switch (item){
            case 'weather':
                result = {color:"rgba(37,65,114,1)"};
                break;
            case 'input':
                result = {color:"rgba(80,80,80,1)"};
                break;
            case 'output':
                result = {color:"rgba(0,170,100,1)"};
                break;
            case 'alert':
                result = {color:"rgba(205,60,60,1)"};
                break;
            default:
                break;

        }

        return result;
    };
}




// WEBPACK FOOTER //
// ./src/shared/stores/news.js